import { useEffect } from 'react';

export const DESKTOP_ON_MOBILE_VIEWPORT_WIDTH = 1280;
export const DESKTOP_ON_MOBILE_INITIAL_SCALE = 0.3;

export const MOBILE_VIEWPORT_CONTENT = 'width=device-width, initial-scale=1, shrink-to-fit=no, viewport-fit=cover';
export const DESKTOP_ON_MOBILE_VIEWPORT_CONTENT = `width=${DESKTOP_ON_MOBILE_VIEWPORT_WIDTH}, initial-scale=${DESKTOP_ON_MOBILE_INITIAL_SCALE}, minimum-scale=0.1, maximum-scale=5, user-scalable=yes, viewport-fit=contain`;

export function useMobileLayoutViewport(useDesktopViewport: boolean): void {
  useEffect(() => {
    const viewportMeta = document.querySelector<HTMLMetaElement>('meta[name="viewport"]');
    if (viewportMeta == null) {
      return;
    }

    viewportMeta.content = useDesktopViewport ? DESKTOP_ON_MOBILE_VIEWPORT_CONTENT : MOBILE_VIEWPORT_CONTENT;
  }, [useDesktopViewport]);
}
